import * as actionTypes from "../actionTypes.js";

const initialState = {
  authoritiesList: null,
  authoritiesDropdownList: null,
  dbeList: null,
  dotLicenseBatches: null,
  dotLicenseBatchDetail: null,
  workflowTemplatesList: null,
  workflowTemplateAuthorities: null,
  workflowTemplateGroupsList: null,
  workflowTemplateGroupAuthorities: null,
};

const certificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_AUTHORITIES_CERT:
      return { ...state, authoritiesList: action.payload };
    case actionTypes.GET_AUTHORITIES_DROPDOWN_CERT:
      return { ...state, authoritiesDropdownList: action.payload };
    case actionTypes.GET_DBE_CERT:
      return { ...state, dbeList: action.payload };
    case actionTypes.GET_DOT_LICENSE_BATCHES_CERT:
      return { ...state, dotLicenseBatches: action.payload };
    case actionTypes.GET_DOT_LICENSE_BATCH_DETAIL_CERT:
      return { ...state, dotLicenseBatchDetail: action.payload };
    case actionTypes.GET_WORKFLOW_TEMPLATES_CERT:
      return { ...state, workflowTemplatesList: action.payload };
    case actionTypes.GET_WORKFLOW_TEMPLATE_AUTHORITIES_CERT:
      return { ...state, workflowTemplateAuthorities: action.payload };
    case actionTypes.CLEAR_WORKFLOW_TEMPLATE_AUTHORITIES_CERT:
      return { ...state, workflowTemplateAuthorities: null };
    case actionTypes.GET_WORKFLOW_TEMPLATE_GROUPS_CERT:
      return { ...state, workflowTemplateGroupsList: action.payload };
    case actionTypes.GET_WORKFLOW_TEMPLATE_GROUP_AUTHORITIES_CERT:
      return { ...state, workflowTemplateGroupAuthorities: action.payload };
    case actionTypes.CLEAR_WORKFLOW_TEMPLATE_GROUP_AUTHORITIES_CERT:
      return { ...state, workflowTemplateGroupAuthorities: null };

    case actionTypes.LOG_OUT:
      return initialState;

    default:
      return state;
  }
};

export default certificationReducer;
